export const MODULES_INFO = {
  ACELERA_MODULE: {
    id: 37
  }
}
